import React from "react";
import { connect } from "react-redux";
import DocumentoMedidasAcciones from "./documento";
import KitPlanMovilidadPlanMovilidad from "./kit";
import Loading from "../../Util/Loading";
import { changeSubMenu, checkMedidasValue } from "../actions";
import DocumentoEstadisticasPlanMovilidad from "./estadisticas";
import { scrollElementToTop, dataLayerTag } from "../functions";

class MainPlanMovilidadPlanMovilidad extends React.PureComponent {

  componentDidMount = () => {
    scrollElementToTop("mainContent");
  }

  render() {
    return (
      <div id="PlanMovilidad_plan_movilidad">
        { this.props.isMedidasLoading && <Loading /> }
        <section id="content-etapa">
          <div className="container-fluid">
            <div className="row PM-plan-borde-spacing">
              <div className="col-md-12 text-center PM-tipo-denuncias-select">
                <div className="row col-md-12 text-center">
                  <div className="PM-section-title col-md-12 text-center">Para definir tu plan de movilidad</div>
                  <div className="col-md-12 text-center"><h5>realiza las siguientes tareas:</h5></div>
                </div>
              </div>
              <div className="col-md-12 text-center PM-plan-contador-tareas PM-home-item-plan">
                <ul>
                  <li className="PM-border-line">
                    <DocumentoEstadisticasPlanMovilidad />
                  </li>
                  <li className="PM-border-line">
                    <DocumentoMedidasAcciones />
                  </li>
                  <li className="PM-border-line">
                    <div className="row">
                      <div className="col-sm-9 text-left">
                        <div className="PM-cuadro-3">
                          <h5><strong>Coordina una reunión con el Comité Paritario para definir qué acciones implementarán y los plazos para ello.</strong></h5>
                          <p>Te recomendamos ajustar las acciones de tu plan en un plazo máximo de 12 meses.</p>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="PM-border-line">
                    <div className="row">
                      <div className="col-sm-9 text-left">
                        <div className="PM-cuadro-3">
                          <h5><strong>Registra las acciones definidas y los plazos en la plataforma.</strong></h5>
                        </div>
                      </div>
                      <div className="col-sm-3 btn-material">
                        <button
                          className="btn PM-dx-button-plan PM-dx-button-plan-100 PM-button-light"
                          onClick={() => {
                            this.props.dispatch(changeSubMenu(1));
                            // gtd -> configuro plan
                            dataLayerTag({
                              'event': 'etapa_3_configurar_plan ',
                              'etapa': '3'
                            });
                          }}
                          disabled={this.props.estadoProceso !== 3}
                          >Configurar Plan</button>
                      </div>
                    </div>
                  </li>
                  <li className="PM-border-line">
                    <KitPlanMovilidadPlanMovilidad />
                  </li>
                  <li className="PM-border-line">
                    <div className="row">
                      <div className="col-md-12 text-center PM-info">
                        <p><strong>Plazo recomendado:</strong> 1 semana</p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="container-fluid PM-btn-box">
            <div className="text-center PM-plan-contador-finalizar">
              <button
                className="btn PM-dx-button-plan PM-dx-button-plan-100 PM-dx-button-plan-aire PM-button-cierre"
                onClick={() => {
                  // verifico si es correcto lo que tiene que mostrar.
                  this.props.dispatch(checkMedidasValue(this.props.idplanMovilidad));
                }}
                disabled={this.props.estadoProceso !== 3 || !this.props.esEncargado}
              > Siguiente
              </button>
            </div>
          </div>
        </section>
        <div className="PM-footer">&nbsp;</div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  usuarioRUT: state.global.userData.RUT,
  usuarioNombre: state.global.userData.FirstName,
  usuarioApellido: state.global.userData.LastName,
  idplanMovilidad: state.planMovilidad.idplanMovilidad,
  habilitarTokenEncuesta: state.planMovilidad.habilitarTokenEncuesta,
  estadoEjecucion: state.planMovilidad.estadoEjecucion,
  estadoPlan: state.planMovilidad.estadoPlan,
  estadoProceso: state.planMovilidad.estadoProceso,
  isMedidasLoading: state.planMovilidad.isMedidasLoading,
  listaContenidos: state.planMovilidad.listaContenidos,
  esEncargado: state.planMovilidad.esEncargado,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(MainPlanMovilidadPlanMovilidad);
